import React, { useState, useEffect} from "react";
import Button from '@mui/material/Button';
import authHeader from "../services/auth-header";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AddIcon from '@mui/icons-material/Add';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Box from '@mui/material/Box';
import axios from "axios";
import AuthService from "../services/auth.service";

import { useTranslation } from "react-i18next";

import ReactDOM from "react-dom";

const api = require("../api/names.js");

function LedTableNew () {

    const { t } = useTranslation("common");

    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [items, setItems] = useState(null);
    const [userID, setUserID] = useState(null);

    const [address, setAddress] = useState(null);
    const [parkingID, setParkingID] = useState(null);
    const [parkingName, setParkingName] = useState(null);
    const [ip, setIp] = useState(null);
    const [description, setDescription] = useState(null);
    const [port, setPort] = useState(3000);

    const [bt1, setBt1] = useState(0);

    useEffect(() => {

        const user = AuthService.getCurrentUser();
        if(user)
            setUserID(user.id);

        var url = api.baseUrl;

        if (userID === 4) {
            url += '/parkings/';
        }
        else {
            url += '/parkings/byUserID/';
            url += userID;
        }
        
        console.log(url);
        fetch(url, {
            method: 'get',
            headers: authHeader()
        })
            .then(res => res.json())
            .then(
                (result) => {
                    setItems(result);
                    console.log(result);
                    setIsLoaded(true);
                },
                (error) => {
                    setIsLoaded(true);
                    setError(error);
                }
            )

    }, []);

    function buttonIsDisabled(prop) {
        if(prop === 0)
            return false;
        else
            return true;
    }

    function buttonColor(prop) {
        if (prop === 0)
            return { backgroundColor: "white" };
        else if(prop === 1)
            return { backgroundColor: "red", color: "white" };
        else
            return { backgroundColor: "green", color: "white" };
    }

    function buttonLabel(prop) {
        if (prop === 0)
            return "Add new table";
        else if(prop === 1)
            return "Error";
        else
            return "Complete";
    }

    function save() {
        if( parkingID && ip && address)
        {
            var url = api.baseUrl + '/ledTables/';
            const jsonData = {
                "address": address,
                "ip": ip,
                "desription": parkingName,
                "street": description,
                "port": port,
                "parkingID": parkingID,
                "userID": userID
            }
            axios.post(url, jsonData, { headers: authHeader() });
            setBt1(2);
        }
        else
            setBt1(1);
        setTimeout(() => setBt1(0), 2000);
    }

    const addressHandler = (e) => {
        var txt = e.target.value;
        setAddress(txt);
    }

    const parkingIdHandler = (e) => {
        var row = items.find(({id})=>id===parseInt(e.target.value));
        setParkingID(row.id);
        setParkingName(row.parkingName);
        setDescription(row.description);
    }

    const parkingNameHandler = (e) => {
        var row = items.find(({ parkingName }) => parkingName === e.target.value);
        setParkingID(row.id);
        setParkingName(row.parkingName);
        setDescription(row.description);
    }

    const ipHandler = (e) => {
        var txt = e.target.value;
        setIp(txt);
    }

    const descHandler = (e) => {
        var txt = e.target.value;
        setDescription(txt);
    }

    const portHandler = (e) => {
        var txt = e.target.value;
        setPort(txt);
    }

    if (error) {
        return <div>{t('detectord.error')}{error.message}</div>;
    } else if (!isLoaded) {
        return <div>{t('detectord.loading')}</div>;
    } else {
        return (
            <Box
                component="form"
                sx={{
                    '& .MuiTextField-root': { m: 1, width: '25ch' },
                }}
                noValidate
                autoComplete="off"
            >
            <div>
                <br />
                <Button href='/parkings' variant="outlined" startIcon={<ArrowBackIcon />}>
                    {t('parkingd.comeback')}
                </Button>
                <br />
                <br />
                <TextField size="large" id="parkingaddress" value={address} onChange={addressHandler} label="Address*" InputLabelProps={{ shrink: true, }} />
                <TextField size="large" id="parkingid" select value={parkingID} onChange={parkingIdHandler} label="Parking ID*" InputLabelProps={{ shrink: true, }}>
                    {items.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                            {option.id}
                        </MenuItem>
                    ))}
                </TextField>
                <TextField size="large" id="parkingname" select value={parkingName} onChange={parkingNameHandler} label="Parking Name*" InputLabelProps={{shrink: true,}}>
                    {items.map((option) => (
                        <MenuItem key={option.parkingName} value={option.parkingName}>
                            {option.parkingName}
                        </MenuItem>
                    ))}
                </TextField>
                <TextField size="large" id="parkingip" value={ip} onChange={ipHandler} label="IP*" InputLabelProps={{ shrink: true, }} />
                <TextField size="large" id="parkingdesc" value={description} onChange={descHandler} label="Street" InputLabelProps={{ shrink: true, }} />
                <TextField size="large" id="parkingport" onChange={portHandler} label="Port" defaultValue={port} />
                <br />
                <br />
                <Button href='/ledTables' onClick={save} variant="outlined" startIcon={<AddIcon />} style={buttonColor(bt1)} disabled={buttonIsDisabled(bt1)}>
                    {buttonLabel(bt1)}
                </Button>
            </div>
            </Box>
        );
    }
}

export default LedTableNew;

ReactDOM.render(<LedTableNew />, document.getElementById("root"));
